import React, { useState } from 'react';
import { INITIAL_DECKS } from '../../hooks/useYonotsune.js';
import { getUILoc, getCardName, groupCards } from '../../utils/cardUtils.js';
import { CardIllustration } from '../Card.js';
import CardDetail from '../CardDetail.js';

const YonotsuneInitialDeckSelection = ({ cardDefs, onSelect, onBack, records }) => {
  const [previewDeck, setPreviewDeck] = useState(null);
  const [selectedMemory, setSelectedMemory] = useState(null);
  const [selectedDetailCard, setSelectedDetailCard] = useState(null);

  const handleOpenPreview = (e, config) => {
    e.stopPropagation();
    setPreviewDeck(config);
  };

  const renderDeckPreviewModal = () => {
    if (!previewDeck) return null;

    const grouped = groupCards(previewDeck.cards);
    const totalCount = previewDeck.cards.length;

    return (
      <div className="player-details-overlay pile-detail-overlay" style={{ zIndex: 3000 }} onClick={() => setPreviewDeck(null)}>
        <div className="player-details-modal pile-detail-modal" onClick={(e) => e.stopPropagation()}>
          <div className="player-details-header">
            <h3>
              {getUILoc(previewDeck.nameKey)} ({getUILoc('UNITS.CARDS', { count: totalCount })})
            </h3>
            <button className="close-button" onClick={() => setPreviewDeck(null)}>×</button>
          </div>
          <div className="player-details-content">
            <div className="pile-cards-grid">
              {grouped.map((item) => {
                const probability = totalCount > 0 ? (item.count / totalCount) * 100 : 0;
                const cardDef = cardDefs?.[item.id];
                return (
                  <div 
                    key={item.id} 
                    className="pile-card-group"
                  >
                    <div className="pile-card-illustration-wrapper">
                      <CardIllustration cardId={item.id} isMini={true} />
                      <div className="pile-card-count-badge">×{item.count}</div>
                      <div className="pile-card-prob-badge">{probability.toFixed(2)}%</div>
                      <button className="inspect-btn-mini" style={{ position: 'absolute', bottom: '2px', right: '2px', zIndex: 5 }} onClick={(e) => { e.stopPropagation(); setSelectedDetailCard(cardDef || { id: item.id }); }}>🔍</button>
                    </div>
                    <div className="pile-card-name">{getCardName(item.id)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMemoryPreviewModal = () => {
    if (!selectedMemory) return null;
    const effect = selectedMemory.memoryEffect;

    return (
      <div className="player-details-overlay pile-detail-overlay" style={{ zIndex: 99999, display: 'flex', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.7)' }} onClick={() => setSelectedMemory(null)}>
        <div className="player-details-modal pile-detail-modal" onClick={(e) => e.stopPropagation()} style={{ background: '#0a192f', padding: '20px', border: '2px solid #2196f3', color: '#fff', maxWidth: '80%' }}>
          <div className="player-details-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
            <h3 style={{ margin: 0 }}>{getUILoc(selectedMemory.nameKey)}</h3>
            <button className="close-button" onClick={() => setSelectedMemory(null)}>×</button>
          </div>
          <div className="player-details-content">
            <p>{getUILoc(selectedMemory.descriptionKey)}</p>
            <hr />
            <h4>{getUILoc('YONOTSUNE.LABELS.EFFECT') || '効果'}</h4>
            <p>{getUILoc(effect.key)}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="yonotsune-screen deck-selection-screen">
      <div className="screen-header">
        <h2 className="yonotsune-title">{getUILoc('YONOTSUNE.DECK_SELECTION.TITLE')}</h2>
        <button className="yonotsune-btn close-btn" onClick={onBack}>
          {getUILoc('BUTTONS.BACK')}
        </button>
      </div>

      <div className="deck-choices-grid">
        {Object.entries(INITIAL_DECKS).map(([key, config]) => {
          const clearCount = records?.clearsByMemory?.[key] || 0;
          return (
            <div key={key} className="initial-deck-card" onClick={() => setSelectedMemory(config)}>
              <div className="card-top-glow"></div>
              <h3>{getUILoc(config.nameKey)}</h3>
              <div className="memory-clear-count-badge" style={{ fontSize: '0.85rem', color: '#adff2f', fontWeight: 'bold', margin: '4px 0 8px 0' }}>
                {getUILoc('YONOTSUNE.RECORDS.CLEAR_COUNT') || 'クリア回数'}: {clearCount}
              </div>
              <p className="deck-desc">{getUILoc(config.descriptionKey)}</p>
              
              <div className="deck-card-actions" onClick={(e) => e.stopPropagation()}>
                <button className="yonotsune-btn check-btn" onClick={(e) => handleOpenPreview(e, config)}>
                  {getUILoc('LABELS.DECK')}
                </button>
                <button className="select-btn" onClick={() => onSelect(key)}>
                  {getUILoc('YONOTSUNE.DECK_SELECTION.SELECT')}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {renderDeckPreviewModal()}
      {renderMemoryPreviewModal()}

      {selectedDetailCard && (
        <CardDetail 
          card={selectedDetailCard} 
          cardDefs={cardDefs}
          onClose={() => setSelectedDetailCard(null)} 
        />
      )}
    </div>
  );
};

export default YonotsuneInitialDeckSelection;
